import jsPDF from "jspdf";

const money = (n) => `EUR ${Number(n || 0).toFixed(2)}`;
const d = (s) => (s ? new Date(s.length === 10 ? `${s}T12:00:00` : s).toLocaleDateString("it-IT") : "");

export const packageContractPdf = (p, me) => {
  const doc = new jsPDF();
  let y = 20;
  const line = (t, size = 10, bold = false) => {
    doc.setFont("helvetica", bold ? "bold" : "normal");
    doc.setFontSize(size);
    doc.splitTextToSize(t, 175).forEach((l) => { if (y > 280) { doc.addPage(); y = 20; } doc.text(l, 17, y); y += size * 0.5; });
    y += 2;
  };
  doc.setFillColor(13, 43, 90);
  doc.rect(0, 0, 210, 14, "F");
  line("CONTRATTO PACCHETTO CHIAVI IN MANO - Artisti in Comune", 14, true);
  line("Documento in MODALITA' SIMULAZIONE: nessun pagamento reale.", 8);
  line(`Evento: ${p.eventType} - ${p.place} - ${p.dateTo && p.dateTo !== p.date ? `dal ${d(p.date)} al ${d(p.dateTo)}` : d(p.date)}`, 11, true);
  line("Parti: il Portale Artisti in Comune ([RAGIONE SOCIALE], P.IVA [P.IVA]) e il Committente " + (p.clientName || "") + ", nonche' ciascun Artista/Fornitore indicato.");
  line("Prestazioni incluse", 11, true);
  p.items.filter((i) => i.status === "accepted").forEach((i) => line(`- ${i.macro}: ${i.name} - cachet ${money(i.net)} (commissione al portale ${i.commissionPct}%)`));
  line("Condizioni di pagamento", 11, true);
  line(`Il Committente paga al Portale l'importo complessivo entro 30 giorni dalla fine dell'evento${p.paymentDueDate ? ` (entro il ${d(p.paymentDueDate)})` : ""}.`);
  line("Distribuzione dei cachet", 11, true);
  line("Il Portale eroga i cachet agli Artisti e Fornitori dopo aver ricevuto il pagamento dal Committente, trattenendo automaticamente da ciascun cachet la percentuale di commissione pattuita.");
  line("Firme digitali", 11, true);
  Object.values(p.signatures || {}).forEach((s) => line(`- ${s.name} - ${new Date(s.at).toLocaleString("it-IT")}`));
  if (me) { line(`Documento scaricato da ${me}`, 8); }
  doc.save(`contratto-pacchetto-${p.id.slice(0, 8)}.pdf`);
};
